import { IMenuItem, MenuItemType } from "dots-ui/dotsMenuBar";
import { NotificationPublisher } from "dots-ui/dotsNotifications";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AvisFooter from "../footer/AvisFooter";
import { AvisNavMenuBar } from "./AvisNavMenuBar";
import classNames from "classnames";

interface ILayoutProps {
  className?: string;
  horizontalMenuItems: MenuItemType[];
  verticalMenuItems: IMenuItem[];
}
export function Layout(props: Readonly<ILayoutProps>) {
  const location = useLocation();

  const { horizontalMenuItems, verticalMenuItems, className } = props;

  useEffect(() => {
    // execute on location change
    NotificationPublisher.closeAllToasts();
  }, [location]);

  const componentClassName = classNames(
    className,
    "avis-content",
    "dots-component",
  );

  return (
    <AvisNavMenuBar
      horizontalMenuItems={horizontalMenuItems}
      verticalMenuItems={verticalMenuItems}
    >
      <div className={componentClassName}>
        <div id="avis-content-wrapper" className="avis-content-wrapper">
          <Outlet />
        </div>
        <AvisFooter />
      </div>
    </AvisNavMenuBar>
  );
}
